
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_16524_44453)"}},[_c('path',{attrs:{"d":"M7.592 15.2l-5.217-4.062 1.283-.997 3.467 2.7v.221c0 .76.174 1.489.467 2.138zM3.665 8.13l-1.29-1.005L9.5 1.583l7.125 5.542-1.298 1.005-.562.436a5.109 5.109 0 00-2.494-.65 5.134 5.134 0 00-4.75 3.207L3.665 8.13z"}}),_c('g',{attrs:{"clip-path":"url(#clip1_16524_44453)"}},[_c('path',{attrs:{"d":"M12.6 12.877a.349.349 0 00-.276.408l1.002 5.152c.036.189.219.312.408.275a.353.353 0 00.202-.114l.724-.864 1.063 1.483c.082.11.218.159.348.134.05-.01.1-.02.142-.065l1.13-.817c.155-.115.195-.337.073-.486l-1.069-1.488 1.045-.413a.403.403 0 00.17-.154.344.344 0 00-.148-.476L12.84 12.91l-.003.005a.346.346 0 00-.236-.038zm2.022.219l-.175-.9 2.25-.438.174.9-2.25.438zm-.985-2.256l1.026-1.52.758.51-1.026 1.521-.758-.51zm-2.14-1.806l.9-.175.438 2.25-.9.174-.437-2.25zM10.05 16.16l1.026-1.52.757.51-1.026 1.521-.757-.51zm-.99-5.093l.51-.757 1.522 1.025-.511.758-1.521-1.026zm1.964 2.728l-2.25.438-.175-.9 2.25-.438.175.9z"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16524_44453"}},[_c('path',{attrs:{"d":"M0 0h19v19H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_16524_44453"}},[_c('path',{attrs:{"transform":"rotate(-11 54.95 -31.395)","d":"M0 0h11v11H0z"}})])])])
          )
        }
      }
    